import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/modal-view/thunks/update-modal-view.ts
var updateModalView = createAsyncThunk(thunkTypes.UPDATE_MODAL_VIEW, async (param, { dispatch }) => {
	if (param?.id) dispatch(actions.updateModalView(param));
	return param;
});
//#endregion
export { updateModalView };

//# sourceMappingURL=update-modal-view.js.map